export const ConsumerPostSubmissionFailedViewStyles = {
  container: 'flex flex-1 flex-col justify-center content-center items-center',
  paragraph: 'text-center mb-4',
  buttonContainer: 'px-6'
}
